// @ts-strict-ignore
import {ButtonOption} from 'common/components/popover-card/types';
import {BarType, SelectedBar} from 'common/report/insights/charts/funnels-step-chart/types';
import {Cohort} from 'common/query-builder/cohorts-query-builder/models/cohort';
import {CohortDetail} from 'common/widgets/create-cohort-button';
import {CalendarDateRange} from 'common/widgets/date-range-picker/models/types';
import {SlottedContent} from 'common/report/insights/charts/funnels-step-chart/popover';

import {CHART_OPTIONS, FLATTENED_CHART_TYPES} from './constants';

export enum StepPopoverAction {
  ViewInFlows = `view-in-flows`,
  ViewUsers = `view-users`,
  ViewReplays = `view-replays`,
}

export interface StepPopoverActionParams {
  action: StepPopoverAction;
  stepIndex: number;
  segmentProp: string;
  isDropOff: boolean;
  color: string;
  metricLabel: string;
  barType: BarType;
  isComparison: boolean;
  comparisonDateRange: CalendarDateRange;
}

export type PopoverParams = {
  /** whether popover is open on the chart */
  open: boolean;
  /** which bar on the chart the popover is targeting */
  bar?: SelectedBar;
  groupByValue?: string;
  /** descriptors of the cohorts which can be created from this bar */
  cohortDetails?: CohortDetail[];
  cohort?: Cohort;
  /** positioning information for the popover */
  styles?: any;
  isSegmented?: boolean;
  isDropOff?: boolean;
  /** displayable segment for the selected bar */
  segmentProp?: string;
  /** header for the popover */
  title?: string;
  /**
   * available actions within the popover
   *
   * TODO for values because it's an akward mix of types at the moment
   */
  /** text to be displayed in the popover */
  buttonOptions?: ButtonOption[];
  slottedContent?: SlottedContent[];

  onAction?: (ev: CustomEvent<{action: string; item: any}>) => void; // TODO typing kinda loose here
  onClose?: () => void;
};

export function formattedChartName(type, style) {
  return CHART_OPTIONS[type][style].name;
}

export function isFlattenedData(chartType) {
  return FLATTENED_CHART_TYPES.includes(chartType);
}
